export default __webpack_public_path__ + "static/media/ug-induction.f6bfacc6.jpg";